
export function PromoCodeModel(dict) {
    this.id = null;
    this.pricePerUnit = dict.Discount;
    this.name = null;
    this.code = null;
    this.codeType = dict.CodeType

    this.setCode = function(code) {
        this.code = code;
        return this;
    }
}
